import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CameraDetailService } from './CameraDetailService';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';

import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { VgAPI } from 'ngx-videogular';
import { zip } from 'rxjs';


@Component({
  selector: 'app-camera-detail',
  templateUrl: './CameraDetail.html',
  styleUrls: ['./CameraDetail.scss'],
})
export class CameraDetailComponent extends AbstractComponent {
  private _el: HTMLElement;
  public video: HTMLVideoElement;

  public scope: any = {
    wait: false,
    id : '',
    videoUrl : null,
    title : '',
    info: null
  };

  /**  */
  constructor(
    private title: Title,
    private route: ActivatedRoute,
    private service: CameraDetailService,
    el: ElementRef
  ) {
    super();
    this._el = el.nativeElement;
  }

  public componentWillMount() {
    window.scrollTo(0, 0);
    this.route.params.subscribe((res:any) => {
      this.scope.id = res.id;
      this.service.get(this.scope.id).subscribe((info:any) => {
        this.title.setTitle(info.streamName);
        this.scope.title = info.streamName;
        this.scope.info = info;
      });
    });
 
  }
  /**  */
  public render() {}
}
